import type { OrganisationSettings } from '@norvix/utils';

import { apiFetch } from './client.js';

/** Settings → Organisation (DEV-138): who Norvix is, stored once. Admin only. */

export interface StoredOrganisation {
  value: OrganisationSettings;
  /** The stored version (DEV-139); sent back on save, so a save over a newer one is refused. */
  version: number;
  updatedAt: string;
  updatedBy: string | null;
  /**
   * Who the daily commission transfer is addressed to: the legal name in
   * capitals unless GuruPay names the account holder itself.
   */
  commissionRecipient?: { followsLegalName: boolean; name: string };
  /** Set instead when the GuruPay Treasury settings cannot be read (DEV-139). */
  commissionRecipientUnavailable?: string;
}

export const organisationApi = {
  get: (): Promise<StoredOrganisation> => apiFetch('/admin/settings/organisation'),
  save: (input: { expectedVersion: number; value: OrganisationSettings; reason: string; confirmCommissionRecipientChange?: boolean }): Promise<StoredOrganisation & { changed: boolean }> =>
    apiFetch('/admin/settings/organisation', { method: 'PUT', body: input }),
};

export const ORGANISATION_KEY = ['organisation-settings'] as const;
